export enum Environment {
  LOCAL = 'local',
  PROD = 'prod'
}

export type AppConfig = {
  apiUrl: string;
};
